<template>
      <v-dialog v-model="dialog" persistent max-width="800px">
      <m-driver-notify-form ref="notifyMessage"></m-driver-notify-form>
      <m-driver-notify-booking ref="notifyBooking"></m-driver-notify-booking>
      <v-card v-if="booking && booking.id">
        <m-route-map ref="routeMap"></m-route-map>
        <v-toolbar dark color="primary elevation-1">
          <v-toolbar-title>Edit booking: {{ booking.id }}</v-toolbar-title>
          <v-spacer></v-spacer>


              <v-btn text icon class="ml-2"  @click.native="showMap">
                <v-icon >public</v-icon>
              </v-btn>
              <div v-if="accepted !== 1 && accepted !== 3" class="notify-wrapper mr-3">
              <v-btn text icon  @click="notifyChange(booking, 0)">
                <v-icon >notifications</v-icon>
              </v-btn>
              <v-btn text icon  @click="notifyChange(booking, 1)">
                <v-icon>h4yIcon-edit_car</v-icon>
              </v-btn>

              <v-btn text icon  @click="notifyChange(booking, 2)">
                <v-icon>h4yIcon-cancel_car</v-icon>
              </v-btn>
            </div>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn dark text @click.native="update">Update</v-btn>
          </v-toolbar-items>
          <v-btn icon @click.native="close" dark>
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-form v-model="valid" ref="form" lazy-validation>
          <v-container grid-list-md>
          <div style="display:flex; align-items: center;" >

            <div class="accepted-wrapper">
              <v-menu >
                <template v-slot:activator="{ on }">
                <v-btn text icon v-on="on" class="status" :class="'accepted-' + accepted">
                  <v-icon v-if="accepted === 1" color="grey">device_unknown</v-icon>
                  <v-icon v-else-if="accepted === 2" color="green">mobile_friendly</v-icon>
                  <v-icon v-else-if="accepted === 3" color="primary">phonelink_erase</v-icon>
                  <v-icon v-else-if="accepted === 4" color="primary">schedule</v-icon>
                  <v-icon v-else color="gray">check</v-icon>
                </v-btn>
                </template>
                <v-list>
                  <v-list-item-group v-model="accepted" @change="changeAccepted(accepted, booking.id)">
                  <v-list-item v-for="state in acceptedList" :key="state.value" :value="state.value">
                    <v-list-item-title :class="{ 'primary--text': accepted === state.value }">{{ state.text }}</v-list-item-title>
                  </v-list-item>
                  </v-list-item-group>
                </v-list>
              </v-menu>


              <v-divider v-if="accepted === 1" vertical></v-divider>
              <v-btn v-if="accepted === 1" text icon  @click="notify(booking, {width: 300, persistent: true})">
                <v-icon >tap_and_play</v-icon>
              </v-btn>



            </div>
            <v-spacer/>
            <v-menu>
              <template v-slot:activator="{ on }">
              <v-btn text outlined v-on="on" @click.prevent class="status" :class="'status-' + form.fields.status">
                {{ form.fields.status | formatIndex(modes) }}
                <v-icon v-if="form.fields.status">lock</v-icon>
                <v-icon v-else>lock_open</v-icon>
              </v-btn>
              </template>
              <v-list>
                <v-list-item-group v-model="form.fields.status">
                <v-list-item v-for="state in status" :key="state.value">
                  <v-list-item-title :class="{ 'primary--text': form.fields.status === state.value }">{{ state.text }}</v-list-item-title>
                </v-list-item>
                </v-list-item-group>
              </v-list>
            </v-menu>


          </div>

            <v-layout wrap>


              <v-flex xs12 sm4>
                <v-autocomplete
                  v-bind:items="drivers"
                  v-model="driverObj"
                  label="Drivers"
                  prepend-icon="directions_car"
                  single-line
                  menu-props="bottom"
                  return-object
                  @change = "onChange"
                  autocomplete
                  :input = booking.driverId
                  :rules="itemRules"
                  required
                ></v-autocomplete>
              </v-flex>
              <v-flex xs12 sm4>
                <v-autocomplete
                  v-bind:items="clients"
                  v-model="clientObj"
                  label="Clients"
                  prepend-icon="accessibility"
                  single-line
                  menu-props="bottom"
                  return-object
                  @change = "onChange"
                  autocomplete
                  :rules="itemRules"
                  required
                ></v-autocomplete>
              </v-flex>
              <v-flex xs12 sm4>
                <v-autocomplete
                  v-bind:items="destinations"
                  v-model="destinationObj"
                  label="Destination"
                  prepend-icon="location_city"
                  single-line
                  menu-props="bottom"
                  return-object
                  @change = "onChange"
                  autocomplete
                  :rules="itemRules"
                  required
                ></v-autocomplete>
              </v-flex>
              <v-flex xs12 class="mb-3">
                <g-input
                  :required="true"
                  id="pickup_edit"
                  ref="pickupAddress"
                  @change="setAddress"
                  @placechanged="setPickup"
                  :label="'Pickup Address'"
                  :delete="true"
                  :rules="itemRules"
                  :error="pickadress_notValid"
                ></g-input>
                <span v-if="pickadress_notValid" class="input-group__details error--text">Address is uncomplete, select a completed address.</span>
              </v-flex>
              <v-flex xs12>
                <m-distance-detail v-if="distance_result && bookingType" :booking="distance_result" :type="bookingType"></m-distance-detail>
              </v-flex>
              <v-flex xs12 sm3>
                    <v-select
                      v-bind:items="types"
                      v-model="bookingType"
                      label="Type"
                      menu-props="bottom"
                      :rules="itemRules"
                      required
                      prepend-icon="low_priority"
                      @change="typeChange"
                    ></v-select>
              </v-flex>
              <v-flex xs12 sm3>
                  <v-select
                    v-bind:items="motives"
                    v-model="form.fields.motive"
                    label="Motive"
                    menu-props="bottom"
                  ></v-select>
              </v-flex>

              <v-flex xs12 sm4>
                <v-menu
                  :close-on-content-click="false"
                  v-model="menu_time"
                  transition="scale-transition"
                  offset-y
                  :nudge-right="40"
                >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-on="on"
                    label="Time"
                    v-model="form.fields.ap_time"
                    prepend-icon="access_time"
                    readonly
                    :rules="itemRules"
                    required
                  ></v-text-field>
                </template>
                  <v-time-picker v-model="form.fields.ap_time"
                  color="primary"
                  format="24hr"
                  autosave
                  @change="menu_time=false"
                  ></v-time-picker>
                </v-menu>
              </v-flex>
              <v-flex xs12 sm3>
                <v-menu
                  :close-on-content-click="false"
                  v-model="menu_date"
                  transition="scale-transition"
                  offset-y
                  :nudge-right="40"
                >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-on="on"
                    label="Date"
                    v-model="dateFormatted"
                    prepend-icon="event"
                    readonly
                    :rules="itemRules"
                    required
                  ></v-text-field>
                </template>
                  <v-date-picker v-model="form.fields.ap_date" no-title scrollable
                    @input="dateFormatted = formatDate($event)"
                    @change="menu_date=false"
                  >
                  </v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex xs3 :class="{'hide' : hideWait}" >
                  <v-select
                    v-bind:items="waits"
                    v-model="waittime"
                    label="Wait time"
                    menu-props="bottom"
                    @change="calcWaitPrice"
                    prepend-icon="add_alarm"
                  ></v-select>
              </v-flex>
              <v-flex xs2 :class="{'hide' : hideWait}" >
                <div class="mt-3 pa-2 text-xs-left"><span class="subheading">{{ waitprice | currency}}</span></div>
              </v-flex>
              <v-flex xs12 sm3>
                <v-text-field
                  label="Ticket price"
                  v-model="form.fields.ticket_price"
                  prepend-icon="euro_symbol"
                  :rules="currencyRules"
                ></v-text-field>
              </v-flex>
              <v-flex xs12><hr class="dotted"></v-flex>
              <v-flex xs12 sm4 >

              <v-checkbox class="mt-3"
                color="primary"
                label="Factuur client?"
                v-model="factuur"
                @change="form.fields.factuur = factuur"
              ></v-checkbox>
              </v-flex>


              <v-flex xs12 sm4 :class="{'hide' : !factuur}">
                <v-text-field
                  label="Factuur price"
                  v-model="form.fields.price"
                  prepend-icon="euro_symbol"
                  :rules="currencyRules"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm4>
                <div v-if="basePrice" class="text-right">({{ basePrice | currency }})</div>
              </v-flex>
              <v-flex xs12><hr class="dotted"></v-flex>
              <v-flex xs12 sm4>
                <div class="invoice-label">Driver:</div>
                <v-text-field
                  label="Price"
                  v-model="form.fields.price_driver"
                  prepend-icon="euro_symbol"
                  @change="changePrice"
                  :rules="currencyRules"
                ></v-text-field>

              </v-flex>
              <v-divider inset vertical class="pl-3"></v-divider>
              <v-flex xs12 sm6 class="pl-3">
                <div class="invoice-label">
                <v-checkbox class="mt-3"
                  color="primary"
                  label="Factuur driver?"
                  v-model="factuurDriver"
                  @change="form.fields.factuurDriver = factuurDriver"
                ></v-checkbox>
                  <v-checkbox class="mt-3"
                  color="primary"
                  label="Credit driver?"
                  v-model="creditDriver"
                  @change="form.fields.creditDriver = creditDriver"
                ></v-checkbox>

                </div>
                <div class="ml-3 mb-2 invoiceAddress" :class="{'hide' : !creditDriver}">
                  <v-text-field
                    label="Credit"
                    v-model="form.fields.creditAmount"
                    prepend-icon="euro_symbol"
                    @change="changePrice"
                    :rules="currencyRules"
                  ></v-text-field>
                  <v-text-field
                    label="Reason"
                    v-model="form.fields.creditReason"
                    prepend-icon="chat"
                    @change="changePrice"
                  ></v-text-field>
                </div>
              </v-flex>
              <v-flex v-if="mutual && form.fields.certificateNeeded" xs12 sm3>
                <v-checkbox
                color="primary"
                label="Certificat reçu"
                v-model="form.fields.certificateReceived"
              ></v-checkbox>
              </v-flex>








              <v-flex xs12><hr class="dotted"></v-flex>

              <v-flex xs12 sm3 >
              <v-checkbox class="mt-3" @change="toggleMutual"
              color="primary"
                label="Insurance?"
                v-model="mutual"
              ></v-checkbox>
              </v-flex>

              <v-flex xs12 v-if="mutual">
                <v-layout wrap class="invoiceAddress">
                  <v-flex xs12>
                    <div class="invoice-label">
                      Mutual:
                      <v-icon v-if="mutual && form.fields.mutualPatientID"
                        small
                        class="float-right mr-2"
                        @click="openBooqit(form.fields.mutualPatientID)" > visibility </v-icon>
                    </div>
                  </v-flex>

                  <v-flex xs12 sm4>
                        <v-autocomplete
                          v-bind:items="insurances"
                          v-model="insuranceObj"
                          label="Insurance"
                          prepend-icon="location_city"
                          single-line
                          menu-props="bottom"
                          return-object
                          @change = "onChangeInsurance"
                          autocomplete
                          :rules="itemRules"
                          required
                        ></v-autocomplete>
                  </v-flex>
                  <v-flex xs12 sm4 ></v-flex>
                  <v-flex xs12 sm4>
                    <v-spacer></v-spacer>
                    <v-checkbox class="mt-3"
                      append-icon="receipt"
                      color="primary"
                      label="Certificat est requis"
                      v-model="form.fields.certificateNeeded"
                    ></v-checkbox>
<!--                     <div>
                       <v-file-input dense multiple
                       v-model="certificateFiles"
                       small-chips
                       @change = "onChangeCertificate"
                       @click:clear = "onClearCertificate"
                       label="Upload Certificat"></v-file-input>
                    </div> -->
                  </v-flex>
                  <v-flex xs12 sm4>
                    <v-text-field v-model="form.fields.mutualPatientID" :rules="itemRules" required label="Trip ID"></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm4>
                    <v-text-field prepend-icon="place" v-model="form.fields.mutualDistance" label="Distance"></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm4>
                    <v-text-field prepend-icon="euro_symbol" v-model="form.fields.mutualAmount" :rules="currencyRules" label="Price fix"></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm4>
                    <v-text-field prepend-icon="euro_symbol" v-model="form.fields.mutualPatientAmount" :rules="currencyRules" label="Price patient"></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm12>

                    <v-checkbox class="mt-3"
                      color="primary"
                      label="Pas intervention Mutuelle"
                      v-model="form.fields.noMutIntervention"
                    ></v-checkbox>
                  </v-flex>
                  <v-flex xs12>
                    <v-text-field v-model="form.fields.mutualComment" label="Comment"></v-text-field>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex xs12><hr class="dotted"></v-flex>
              <v-flex xs12 v-if="form.fields.info">
                <v-icon>info</v-icon>  <span>Info: </span> <span>{{ form.fields.info }}</span>
              </v-flex>
              <v-flex xs12>
                <v-textarea
                  label="Comment"
                  v-model="form.fields.comment"
                  prepend-icon="chat"
                  multi-line
                ></v-textarea>
              </v-flex>
            </v-layout>
        </v-container>
        <small>*indicates required field</small>
        </v-form>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
  import BookingFormEditMixin from '@/mixins/booking-form-edit'
  import BookingFormMixin from '@/mixins/booking-form'
  import NotifyMixin from '@/mixins/notification'
  import NotifyBooking from '../../components/notification/notify-booking'
  import NotifyMessage from '../../components/notification/notify-form'
  export default {
    mixins: [BookingFormEditMixin, NotifyMixin],
    components: {
      'm-driver-notify-form': NotifyMessage,
      'm-driver-notify-booking': NotifyBooking
    },
    data () {
      return {}
    },
    methods: {}
  }
</script>
<style lang="scss">
  .hide {
      display: none
  }
  hr.dotted {border: 1px dashed #e5332a; border-style: none none dashed; color: #fff; background-color: #fff; }
  .notify-wrapper {
    display: flex;
    border: solid 1px rgba(255, 255, 255, 0.5);
    color: rgba(255, 255, 255, 0.5);
    border-radius: 4px

  }
  .accepted-wrapper {
    display: flex;
    border: solid 1px rgba(0,0,0,.12);
    color: rgba(0,0,0,.12);
    border-radius: 4px

  }
</style>
